import { STORAGE_TOKEN } from "constants/common/common";
import { io, Socket } from "socket.io-client";

export const WS_EVENTS = {
  PAYMENT_CREATED: "payment:created",
  PAYMENT_REVIEWED: "payment:reviewed",
  EXPORT_DONE: "export:done",
  EXPORT_FAILED: "export:failed",
} as const;

export type PaymentCreatedPayload = {
  journalId: string;
  code: string;
  amount: number;
  notificationId: string;
};

export type PaymentReviewedPayload = {
  journalId: string;
  status: "approved" | "rejected";
  note?: string;
  notificationId: string;
};

export type ExportDonePayload = {
  jobId: string;
  fileName?: string;
  downloadUrl: string;
  notificationId: string;
};

export type ExportFailedPayload = {
  jobId: string;
  error: string;
  notificationId: string;
};

const getSocketBaseUrl = () => {
  const envUrl = import.meta.env.VITE_SERVER_URL;
  const fallbackUrl = window.location.origin;
  return (envUrl || fallbackUrl).replace(/\/api\/?$/, "").replace(/\/$/, "");
};

export const getStoredAccessToken = (): string | null => {
  const tokenString = localStorage.getItem(STORAGE_TOKEN);
  if (!tokenString) return null;

  try {
    const tokenData = JSON.parse(tokenString);
    return tokenData?.access_token ?? null;
  } catch {
    return null;
  }
};

export function createNotificationSocket(accessToken: string): Socket {
  return io(`${getSocketBaseUrl()}/notifications`, {
    transports: ["websocket"],
    auth: {
      token: accessToken,
    },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });
}
